import { LogsData } from '@/types/general';
import { MRT_ColumnDef } from 'mantine-react-table';

export const columnsArrayLogs: MRT_ColumnDef<LogsData>[] = [
  {
    accessorKey: 'username',
    header: 'Utilisateur',
    size: 10,
    mantineTableHeadCellProps: {
      align: 'center',
    },
  },
  {
    accessorKey: 'date_time',
    header: 'Date/Heure',
    mantineTableHeadCellProps: {
      align: 'center',
    },
  },
  {
    accessorKey: 'ip_address',
    header: 'Adresse IP',
    mantineTableHeadCellProps: {
      align: 'center',
    },
  },
  {
    accessorKey: 'os',
    header: 'OS',
    mantineTableHeadCellProps: {
      align: 'center',
    },
  },
  {
    accessorKey: 'actions',
    header: 'Action',
    size: 50,
    mantineTableHeadCellProps: {
      align: 'center',
    },
  },
];
